export const npcTexts = [
  'Welcome to Pump.Fun World, degen! 🚀',
  'This place is totally awesome!',
  'Love the vibes here, everything is so chill! 💎',
  'Hope you enjoy exploring around!',
  'The community here is amazing!',
  'Have you tried the arcade over there?',
  'This world has so many cool spots to discover! 📈',
  'Remember: Stay positive and have fun! 🌙',
  'WAGMI, anon! Enjoy your stay! 🚀💎',
];
